import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { CreditCard } from 'lucide-react';

export function StripeConfigCard() {
  return (
    <Card>
      <CardHeader title="Stripe" />
      <CardContent>
        <div className="flex items-center gap-3">
          <CreditCard className="h-8 w-8 text-primary-400" />
          <div>
            <p className="text-sm font-medium text-neutral-900 dark:text-neutral-200">Stripe connecté</p>
            <Badge variant="success" className="mt-1">Actif</Badge>
          </div>
        </div>
        <div className="mt-4 space-y-2 text-sm">
          <div className="flex justify-between text-neutral-600 dark:text-neutral-400">
            <span>Mode</span><span className="text-neutral-900 dark:text-neutral-200">Production</span>
          </div>
          <div className="flex justify-between text-neutral-600 dark:text-neutral-400">
            <span>Webhook</span><Badge variant="success">OK</Badge>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
